export const services = [
    {
        image:"images/service.png",
        title:"Free Shipping",
        tagline:"From all orders over $100"
    },
    {
        image:"images/service-02.png",
        title:"Daily Suprise Offers",
        tagline:"Save upto 25% off"
    },
    {
        image:"images/service-03.png",
        title:"Support 24/7",
        tagline:"Shop With An Expert"
    },
    {
        image:"images/service-04.png",
        title:"Affordable Prices",
        tagline:"Get Factory Default Price"
    },
    {
        image:"images/service-05.png",
        title:"Secure Payments",
        tagline:"100% Protected Payment"
    },
];